import { useTranslation } from 'react-i18next';

// Accepts obj that contains language keys (e.g. en, fr, etc.) and returns localized data by current language
const useLocalizedData = () => {
  const { i18n } = useTranslation();

  return obj => {
    if (!obj) return '';
    return obj[i18n.language] || obj['en'] || '';
  };
};

export default useLocalizedData;
